import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm$otherTags;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("后台标签")]), _c("div", {
    staticClass: "tag-list"
  }, [_vm._l(_vm.tagList, function (tag, index) {
    return _c("el-tag", {
      key: index,
      attrs: {
        size: "medium",
        type: _vm.setType(tag) ? "" : "info"
      },
      on: {
        click: function click($event) {
          return _vm.selectTag(tag);
        }
      }
    }, [_vm._v("#" + _vm._s(tag) + " ")]);
  }), _c("el-popover", {
    attrs: {
      placement: "bottom-start",
      width: "180",
      trigger: "click",
      "popper-class": "el-popover-tag"
    },
    on: {
      show: _vm.showSearch
    }
  }, [_c("div", {
    staticClass: "tag-search-box"
  }, [_c("el-input", {
    staticClass: "search-input",
    attrs: {
      placeholder: "",
      size: "small"
    },
    on: {
      input: _vm.search
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "other-tags"
  }, [(_vm$otherTags = _vm.otherTags) !== null && _vm$otherTags !== void 0 && _vm$otherTags.length ? _vm._l(_vm.otherTags, function (item, key) {
    return _c("div", {
      key: key,
      staticClass: "tag-item"
    }, [_c("span", {
      staticClass: "label"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c("span", {
      staticClass: "choose",
      on: {
        click: function click($event) {
          return _vm.chooseTag(item.name);
        }
      }
    }, [_vm._v("选择")])]);
  }) : _vm.emptyTag ? [_c("div", {
    staticClass: "tag-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.emptyTag) + " ")]), _c("span", {
    staticClass: "choose",
    on: {
      click: function click($event) {
        return _vm.createTag(_vm.item);
      }
    }
  }, [_vm._v("+创建标签")])])] : _vm._e()], 2)], 1), _c("el-tag", {
    attrs: {
      slot: "reference",
      type: "info",
      size: "medium"
    },
    slot: "reference"
  }, [_vm._v(" +添加 ")])], 1)], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };